<div class="layout--desktop cardContainer">
  <ng-template *ngTemplateOutlet="desktopTemplate"></ng-template>
</div>

<div class="layout--tablet" [ngClass]="{ 'has-match': discontinued === false }">
  @if (!discontinued) {
    <ng-template *ngTemplateOutlet="mobileTemplate"></ng-template>
  }
  @if (discontinued) {
    <ng-template *ngTemplateOutlet="desktopTemplate"></ng-template>
  }
</div>

<div class="layout--mobile" [ngClass]="{ 'has-match': discontinued === false }">
  @if (!discontinued) {
    <ng-template *ngTemplateOutlet="mobileTemplate"></ng-template>
  }
  @if (discontinued) {
    <ng-template *ngTemplateOutlet="desktopTemplate"></ng-template>
  }
</div>
<ng-template #desktopTemplate>
  <div class="comparison-card__container__header">
    @if (
      configs.displayPlansTypeLabel && comparePlansObj?.plansTypeLabel?.length
    ) {
      <p class="t-bold" data-test-id="comparisonCardDesktopDisplayPlanType">
        {{ comparePlansObj.plansTypeLabel | titlecase }}
      </p>
    }

    <form-control
      [group]="selectOrChoosePlanFormGroup"
      [config]="configs.selectOrChoosePlanToggleControl"
      [control]="
        selectOrChoosePlanFormGroup.get(
          configs.selectOrChoosePlanToggleControl.prop
        )
      "
      data-test-id="comparisonCardDesktopChoosePlanControl"
    >
    </form-control>
  </div>
  <div
    class="comparison-card__container"
    [ngStyle]="{ width: width }"
    [ngClass]="{ 'no-match': discontinued === true }"
  >
    <ng-template *ngTemplateOutlet="summaryDesktopLayout"></ng-template>
    <ng-template *ngTemplateOutlet="showDetailsTemplate"></ng-template>
    <ng-template *ngTemplateOutlet="detailsDesktopLayout"></ng-template>
  </div>
</ng-template>

<ng-template #mobileTemplate>
  <div class="comparison-card__container" [ngStyle]="{ width: width }">
    <ng-template *ngTemplateOutlet="summaryMobileLayout"></ng-template>
    <ng-template *ngTemplateOutlet="showDetailsTemplate"></ng-template>
    <ng-template *ngTemplateOutlet="detailsMobileLayout"></ng-template>
  </div>
</ng-template>

<ng-template #showDetailsTemplate>
  <div
    class="comparision-card__show_details_toggle"
    [ngClass]="{ 'details-open': showDetails, 'details-closed': !showDetails }"
  >
    <div
      (click)="showDetails = !showDetails"
      data-test-id="comparisonCardShowDetails"
    >
      <i class="icon icon--medium" data-test-id="comparisonCardChevronIcon"
        >chevron_{{ showDetails ? 'up' : 'down' }}</i
      >
      <p class="t-bold" data-test-id="comparisonCardDetails">
        {{ showDetails ? 'Hide' : 'View' }} Details
      </p>
    </div>

    @if (ctas && ctas.length > 0) {
      <div class="comparison-card__ctas">
        @for (action of ctas; track action; let i = $index) {
          <i
            class="icon icon--medium"
            (click)="initCta($event, action)"
            [attr.data-test-id]="'comparisonCardCtaAction-' + i"
            >{{ action }}</i
          >
        }
      </div>
    }
  </div>
</ng-template>

<ng-template
  #planRow
  let-label="label"
  let-plan1Value="plan1Value"
  let-plan2Value="plan2Value"
>
  <div class="comparison-card__wrapper">
    <div class="comparison-card__labels">
      <p class="t-bold" data-test-id="comparisonCardPlanRowlabel">
        {{ label }}
      </p>
    </div>
    <div class="comparison-card__values values-col-1">
      <p class="t-bold" data-test-id="comparisonCardPlan1Value">
        {{ plan1Value }}
      </p>
    </div>
    @if (!discontinued) {
      <div class="comparison-card__values">
        <p class="t-bold" data-test-id="comparisonCardPlan2Value">
          {{ plan2Value }}
        </p>
      </div>
    }
  </div>
</ng-template>

<ng-template
  #planRowMobile
  let-label="label"
  let-plan1Value="plan1Value"
  let-plan2Value="plan2Value"
>
  <div class="comparison-card__wrapper">
    <div
      class="comparison-card__values values-col-1"
      [ngClass]="{ 'plan-discontinued': discontinued }"
    >
      <p class="t-bold" data-test-id="comparisonPlanRowMobileLabel">
        {{ label }}
      </p>
      <p
        [ngClass]="{ 't-bold': i < 4 && discontinued }"
        data-test-id="comparisonPlan1MobileValue"
      >
        {{ plan1Value }}
      </p>
    </div>
    @if (!discontinued) {
      <div class="comparison-card__values">
        <p class="spacer" data-test-id="comparisonCardSpacer"></p>
        <p data-test-id="comparisonPlan2MobileValue">{{ plan2Value }}</p>
      </div>
    }
  </div>
</ng-template>

<ng-template #summaryDesktopLayout>
  <div class="comparison-card__headers u-flex">
    @if (useBenefitsIndex) {
      <div class="comparison-card__headers-wrapper u-flex">
        @if (discontinued != true) {
          <div class="label-col"></div>
        }
        @if (!discontinued) {
          <div class="plan-col plan-1-col">
            <h6
              class="t-bold"
              data-test-id="comparisonSummaryDesktopCrossWalkPlanYear"
            >
              {{ comparePlansObj.crossWalkPlan?.year }}
            </h6>
          </div>
        }
        <div class="plan-col plan-2-col">
          <h6
            class="t-bold"
            data-test-id="comparisonSummaryDesktopPreviousPlanYear"
          >
            {{ comparePlansObj.previousPlan?.year }}
          </h6>
        </div>
        @if (discontinued && !ineligible) {
          <div class="plan-discontinued">
            <p
              class="t-bold"
              data-test-id="comparisonSummaryDesktopPlanDiscontinuedMessage"
            >
              <i
                class="icon icon--medium"
                data-test-id="comparisonSummaryDesktopErrorIcon"
                >error</i
              >This plan has been discontinued
            </p>
          </div>
        }
      </div>
    } @else {
      <div class="comparison-card__headers-wrapper u-flex">
        @if (discontinued != true) {
          <div class="label-col"></div>
        }
        <div class="plan-col plan-1-col">
          <h6
            class="t-bold"
            data-test-id="comparisonDefaultDesktopPreviousPlanYear"
          >
            {{ comparePlansObj.previousPlan?.year }}
          </h6>
        </div>
        @if (!discontinued) {
          <div class="plan-col plan-2-col">
            <h6
              class="t-bold"
              data-test-id="comparisonDefaultDesktopCrossWalkPlanYear"
            >
              {{ comparePlansObj.crossWalkPlan?.year }}
            </h6>
          </div>
        }
        @if (discontinued && !ineligible) {
          <div class="plan-discontinued">
            <p
              class="t-bold"
              data-test-id="comparisonDefaultDesktopPlanDiscontinuedMessage"
            >
              <i
                class="icon icon--medium"
                data-test-id="comparisonDefaultDesktopErrorIcon"
                >error</i
              >This plan has been discontinued
            </p>
          </div>
        }
      </div>
    }
  </div>

  <!--TODO: make plan1Value and plan2Value into getters to reduce duplication in the template -hlopez -->
  <div class="comparison-card__content comparison-card__summary">
    @for (config of configs.additionalPlanDetails; track config) {
      @if (useBenefitsIndex) {
        <ng-container
          *ngTemplateOutlet="
            planRow;
            context: {
              label: config.label,
              plan2Value:
                comparePlansObj.previousPlan &&
                format((comparePlansObj?.previousPlan)[config.prop], config),
              plan1Value:
                comparePlansObj.crossWalkPlan &&
                format((comparePlansObj?.crossWalkPlan)[config.prop], config),
            }
          "
        >
        </ng-container>
      } @else {
        <ng-container
          *ngTemplateOutlet="
            planRow;
            context: {
              label: config.label,
              plan1Value:
                comparePlansObj.previousPlan &&
                format((comparePlansObj?.previousPlan)[config.prop], config),
              plan2Value:
                comparePlansObj.crossWalkPlan &&
                format((comparePlansObj?.crossWalkPlan)[config.prop], config),
            }
          "
        >
        </ng-container>
      }
    }

    @for (
      plan of comparePlansObj.summary | keyvalue;
      track plan;
      let i = $index
    ) {
      <div
        class="comparison-card__wrapper"
        [ngClass]="{ 'border-btm': i === 3 }"
      >
        <div class="comparison-card__labels">
          <p
            class="t-bold"
            [attr.data-test-id]="'comparisonSummarDesktopPlanKey-' + i"
          >
            {{ plan.key }}
          </p>
        </div>
        <div
          class="comparison-card__values values-col-1"
          [ngClass]="{ 'plan-discontinued': discontinued === true }"
        >
          <p
            [ngClass]="{ 't-bold': i < 4 }"
            [attr.data-test-id]="'comparisonSummaryDesktopPlan1Value-' + i"
          >
            {{ plan.value[0] }}
          </p>
        </div>
        @if (!discontinued) {
          <div class="comparison-card__values">
            <p
              [ngClass]="{ 't-bold': i < 4 }"
              [attr.data-test-id]="'comparisonSummaryDesktopPlan2Value-' + i"
            >
              {{ plan.value[1] }}
            </p>
          </div>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #summaryMobileLayout>
  <div class="comparison-card__headers u-flex">
    <div class="comparison-card__headers-wrapper u-flex">
      <div class="plan-col plan-1-col">
        <h6
          class="t-bold"
          data-test-id="comparisonSummaryMobilePreviousPlanYear"
        >
          {{ comparePlansObj.previousPlan?.year }}
        </h6>
      </div>
      @if (!discontinued) {
        <div class="plan-col plan-2-col">
          <h6
            class="t-bold"
            data-test-id="comparisonSummaryMobilePreviousPlanName"
          >
            {{ comparePlansObj.previousPlan?.name }}
          </h6>
        </div>
      }
      @if (discontinued && !ineligible) {
        <div class="plan-discontinued">
          <p
            class="t-bold"
            data-test-id="comparisonSummaryMobilePlanDiscontinuedMessage"
          >
            <i
              class="icon icon--medium"
              data-test-id="comparisonSummaryMobileErrorIcon"
              >error</i
            >
            This plan has been discontinued
          </p>
        </div>
      }
    </div>
  </div>

  <div class="comparison-card__content comparison-card__summary">
    @for (config of configs.additionalPlanDetails; track config) {
      @if (useBenefitsIndex) {
        <ng-container
          *ngTemplateOutlet="
            planRowMobile;
            context: {
              label: config.label,
              plan2Value:
                comparePlansObj.previousPlan &&
                format((comparePlansObj?.previousPlan)[config.prop], config),
              plan1Value:
                comparePlansObj.crossWalkPlan &&
                format((comparePlansObj?.crossWalkPlan)[config.prop], config),
            }
          "
        >
        </ng-container>
      } @else {
        <ng-container
          *ngTemplateOutlet="
            planRowMobile;
            context: {
              label: config.label,
              plan1Value:
                comparePlansObj.previousPlan &&
                format((comparePlansObj?.previousPlan)[config.prop], config),
              plan2Value:
                comparePlansObj.crossWalkPlan &&
                format((comparePlansObj?.crossWalkPlan)[config.prop], config),
            }
          "
        >
        </ng-container>
      }
    }
    @for (
      plan of comparePlansObj.summary | keyvalue;
      track plan;
      let i = $index
    ) {
      <div class="comparison-card__wrapper">
        <div
          class="comparison-card__values values-col-1"
          [ngClass]="{ 'plan-discontinued': discontinued }"
        >
          <p class="t-bold" data-test-id="comparisonSummaryMobileKey">
            {{ plan.key }}
          </p>
          <p
            [ngClass]="{ 't-bold': i < 4 && discontinued }"
            data-test-id="comparisonSummaryMobilePlanValue1"
          >
            {{ plan.value[0] }}
          </p>
        </div>
        @if (!discontinued) {
          <div class="comparison-card__values">
            <p
              class="spacer"
              data-test-id="comparisonCardSummaryMobileSpacer"
            ></p>
            <p data-test-id="comparisonSummaryMobilePlanValue2">
              {{ plan.value[1] }}
            </p>
          </div>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #detailsDesktopLayout>
  @if (showDetails) {
    <div>
      @if (useBenefitsIndex) {
        <div class="comparison-card__content comparison-card__details">
          @for (plan of comparePlansObj.details; track plan; let i = $index) {
            <div>
              @if (isArray(plan.value)) {
                <div class="comparison-card__wrapper">
                  @for (
                    benefits of plan.formattedBenefits;
                    track benefits;
                    let j = $index
                  ) {
                    <div class="plan-row">
                      <p
                        [attr.data-test-id]="
                          'comparisonCardBenefit-' + i + '-' + j
                        "
                      >
                        {{ benefits }}
                      </p>
                    </div>
                  }
                  <div class="comparison-card__labels">
                    <p
                      class="t-bold"
                      [attr.data-test-id]="
                        'comparisonDetailsDesktopPlanLabel-' + i
                      "
                    >
                      {{ plan.label }}
                    </p>
                  </div>
                  <div class="comparison-card__values values-col-1">
                    @if (plan.type !== 'link') {
                      <p
                        [innerHTML]="plan.value[0]"
                        [attr.data-test-id]="
                          'comparisonDetailsDesktopPlanValue1-' + i
                        "
                      ></p>
                    }
                    @if (plan.type === 'link') {
                      <a
                        [href]="plan.value[0]"
                        class="t-link"
                        target="_blank"
                        [attr.data-test-id]="
                          'comparisonDetailsDesktopPlanLink1-' + i
                        "
                        >{{ plan.label }}</a
                      >
                    }
                  </div>
                  @if (!discontinued) {
                    <div class="comparison-card__values">
                      @if (plan.type !== 'link') {
                        <p
                          [innerHTML]="plan.value[1]"
                          [attr.data-test-id]="
                            'comparisonDetailsDesktopPlanValue2-' + i
                          "
                        ></p>
                      }
                      @if (plan.type === 'link' && !!plan.value[1]) {
                        <a
                          [href]="plan.value[1]"
                          class="t-link"
                          target="_blank"
                          [attr.data-test-id]="
                            'comparisonDetailsDesktopPlanLink2-' + i
                          "
                          >{{ plan.label }}</a
                        >
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      } @else {
        <div class="comparison-card__content comparison-card__details">
          @for (
            plan of comparePlansObj.detailsMap | keyvalue: originalOrder;
            track plan;
            let i = $index
          ) {
            <div class="comparison-card__wrapper">
              @for (
                benefits of plan.formattedBenefits;
                track benefits;
                let j = $index
              ) {
                <div class="plan-row">
                  <p
                    [attr.data-test-id]="
                      'comparisonDefaultDesktopBenefit-' + i + '-' + j
                    "
                  >
                    {{ benefits }}
                  </p>
                </div>
              }
              <div class="comparison-card__labels">
                <p
                  class="t-bold"
                  [attr.data-test-id]="'comparisonDefaultDesktopPlanKey-' + i"
                >
                  {{ plan.key }}
                </p>
              </div>
              <div class="comparison-card__values values-col-1">
                @if (plan.value[0]) {
                  <p
                    [innerHTML]="plan.value[0]"
                    [attr.data-test-id]="
                      'comparisonDefaultDesktopPlanValue1-' + i
                    "
                  ></p>
                }
              </div>
              @if (!discontinued) {
                <div class="comparison-card__values">
                  <p
                    [innerHTML]="plan.value[1]"
                    [attr.data-test-id]="'comparisonCardPlanValue2-' + i"
                  ></p>
                </div>
              }
            </div>
          }
        </div>
      }
      <!-- need to preserve backwards compatiblity for clients that don't have benefit_display_index -->
    </div>
  }
</ng-template>

<ng-template #detailsMobileLayout>
  @if (showDetails) {
    <div>
      @if (useBenefitsIndex) {
        <div class="comparison-card__content comparison-card__details">
          @for (plan of comparePlansObj.details; track plan; let i = $index) {
            <div>
              @if (isArray(plan.value)) {
                <div class="comparison-card__wrapper">
                  @for (
                    benefits of plan.formattedBenefits;
                    track benefits;
                    let idx2 = $index
                  ) {
                    <div class="plan-row"></div>
                  }
                  <div class="comparison-card__values values-col-1">
                    <p
                      class="t-bold"
                      [attr.data-test-id]="
                        'comparisonShowDetailsPlanLabel-' + i
                      "
                    >
                      {{ plan.label }}
                    </p>
                    @if (plan.type !== 'link') {
                      <p
                        [innerHTML]="plan.value[0]"
                        [attr.data-test-id]="
                          'comparisonShowDetailPlanValue1-' + i
                        "
                      ></p>
                    }
                    @if (plan.type === 'link') {
                      <a
                        [href]="plan.value[0]"
                        class="t-link"
                        target="_blank"
                        [attr.data-test-id]="
                          'comparisonShowDetailsPlanLink1-' + i
                        "
                      >
                        {{ plan.label }}
                      </a>
                    }
                  </div>
                  @if (!discontinued) {
                    <div class="comparison-card__values">
                      <p
                        class="spacer"
                        data-test-id="comparisonShowDetailsSpacer"
                      ></p>
                      @if (plan.type !== 'link') {
                        <p
                          [innerHTML]="plan.value[1]"
                          [attr.data-test-id]="
                            'comparisonShowDetailsPlanValue2-' + i
                          "
                        ></p>
                      }
                      @if (plan.type === 'link' && !!plan.value[1]) {
                        <a
                          [href]="plan.value[1]"
                          class="t-link"
                          target="_blank"
                          [attr.data-test-id]="
                            'comparisonShowDetailsPlanLink2-' + i
                          "
                        >
                          {{ plan.label }}
                        </a>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      } @else {
        <div class="comparison-card__content comparison-card__details">
          @for (
            plan of comparePlansObj.detailsMap | keyvalue;
            track plan;
            let i = $index
          ) {
            <div class="comparison-card__wrapper">
              @for (
                benefits of plan.formattedBenefits;
                track benefits;
                let idx2 = $index
              ) {
                <div class="plan-row"></div>
              }
              <div class="comparison-card__values values-col-1">
                <p
                  class="t-bold"
                  [attr.data-test-id]="'comparisonDefaultMobilePlanKey-' + i"
                >
                  {{ plan.key }}
                </p>
                <p
                  [innerHTML]="plan.value[0]"
                  [attr.data-test-id]="'comparisonDefaultMobilePlanValue1-' + i"
                ></p>
              </div>
              @if (!discontinued) {
                <div class="comparison-card__values">
                  <p
                    class="spacer"
                    data-test-id="comparisonDefaultMobileSpacer"
                  ></p>
                  <p
                    [innerHTML]="plan.value[1]"
                    [attr.data-test-id]="
                      'comparisonDefaultMobilePlanValue2-' + i
                    "
                  ></p>
                </div>
              }
            </div>
          }
        </div>
      }
      <!-- need to preserve backwards compatiblity for clients that don't have benefit_display_index -->
    </div>
  }
</ng-template>
